export const formatDate = (date, min = false) => {
  if (min) {
    return `${date.getUTCDate()} ${date.getUTCFullYear()}`;
  }
  return `${date.getUTCDate()} ${date.toLocaleString("default", {
    month: "long",
  })} ${date.getUTCFullYear()}`;
};

export const convertDate = (date) => {
  const newDate = new Date(date);
  return (
    newDate.getMonth() +
    1 +
    "/" +
    newDate.getDate() +
    "/" +
    newDate.getFullYear()
  );
};

export const getFullName = (user) => {
  if (!user) {
    return null;
  }

  if (user?.first_name && user?.last_name) {
    return `${user?.first_name} ${user?.last_name}`;
  }
  if (user?.email) {
    return user.email;
  }
  if (user?.phone_number) {
    return user.phone_number;
  }
  return null;
};

export const getCurrentUser = () => {
  const user = localStorage.getItem("availabilityTracker");
  if (user) {
    return JSON.parse(user)?.user;
  }
  return null;
};
